import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        };
    }

    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({
            hasError: true,
            error: error,
            errorInfo: info
        });
    }

    closeAlert(e) {
        e.preventDefault();
        this.setState({ hasError: false });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="alert_red error-modal">
                    <button onClick={(e) => {this.closeAlert(e)}} className="close-modal"><span className="sr-only">Close Modal</span><i className="fa fa-times-circle gf_invalid"></i></button>
                    <h3>
                        <i className="fa fa-exclamation-triangle gf_invalid"></i>
                        Something went wrong.
                    </h3>
                    <details>
                        <p>{this.state.error && this.state.error.toString()}</p>
                        {this.state.errorInfo.componentStack}
                  </details>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
